import { useState, useEffect, useRef } from 'react';
import { Modal, useAuth, useMutation } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { Html5Qrcode } from 'html5-qrcode';
import { Button } from '@material-ui/core';
import { scanQRCode } from '@webapps/business';
import NewModal from 'pages/school/ClassesPage/ClassesDetail/Components/Modals/NewModal';

const QRScannerModal = ({ open, onClose, onScan }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const [error, setError] = useState(null);
  const [cameras, setCameras] = useState([]);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [step, setStep] = useState(1);
  const scannerRef = useRef(null);

  const { mutateAsync: mutateScanQRCode, isLoading: isLoadingScanQRCode, data: dataScanQRCode } = useMutation(scanQRCode);

  const cleanupScanner = async () => {
    if (scannerRef.current) {
      try {
        await scannerRef.current.stop();
        await scannerRef.current.clear();
        scannerRef.current = null;
      } catch (err) {
        console.warn('Erreur lors du nettoyage du scanner:', err);
      }
    }
  };

  const handleClose = async () => {
    setStep(1);
    await cleanupScanner();
    onClose();
  };


  const handleScanQRCode = async (token) => {
    console.log('Token:', token);
    try {
      const { data } = await mutateScanQRCode({ studentId: idUser, token: token });
      console.log('data', data);
      console.log('data.error', data.error);
      console.log('data.success', data.success);

      if (data.error) {
        setError(data.error);
      } else if (data.success) {
        setStep(2);
        cleanupScanner(); // Arrêter le scanner après le scan réussi
      }
    } catch (error) {
      console.error('Erreur lors du scan du QR Code:', error);
    }
  };

  useEffect(() => {
    const initializeScanner = async () => {
      if (!open) return;

      try {
        const devices = await Html5Qrcode.getCameras();
        setCameras(devices);

        if (devices.length > 0) {
          setSelectedCamera(devices[0].id);
          const html5QrCode = new Html5Qrcode("reader");
          scannerRef.current = html5QrCode;

          await html5QrCode.start(
            devices[0].id,
            {
              fps: 10,
              qrbox: { width: 250, height: 250 },
            },
            (decodedText) => {
              console.log('Code scanné:', decodedText);
              // recuperer après token=
              const token = decodedText.split('token=')[1];
              handleScanQRCode(token);
              // setStep(2);
              cleanupScanner(); // Arrêter le scanner après le scan réussi
            },
            (errorMessage) => {
              // Ignorer les erreurs de scan en continu
              if (!errorMessage.includes("No QR code found")) {
                console.warn(errorMessage);
              }
            }
          );
        } else {
          setError('Aucune caméra trouvée');
        }
      } catch (err) {
        console.error('Erreur d\'initialisation:', err);
        setError('Erreur d\'accès à la caméra. Veuillez vérifier les permissions.');
      }
    };

    if (open) {
      initializeScanner();
    }

    return () => {
      cleanupScanner();
    };
  }, [open]);

  const handleCameraChange = async (event) => {
    const newCameraId = event.target.value;
    setSelectedCamera(newCameraId);

    if (scannerRef.current) {
      await cleanupScanner();
      const html5QrCode = new Html5Qrcode("reader");
      scannerRef.current = html5QrCode;

      await html5QrCode.start(
        newCameraId,
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
        },
        (decodedText) => {
          console.log('Code scanné:', decodedText);
          const token = decodedText.split('token=')[1];
          handleScanQRCode(token);
          // setStep(2);
          cleanupScanner(); // Arrêter le scanner après le scan réussi
        },
        (errorMessage) => {
          if (!errorMessage.includes("No QR code found")) {
            console.warn(errorMessage);
          }
        }
      );
    }
  };

  return (
    <NewModal
      onCancel={handleClose}
      open={open}
      title='Scanner le QR Code'
      subtitle='Placez le QR Code dans le cadre pour scanner'
      actions={[]}
      image={{
        src: "https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png",
        srcSet: "https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png?scale-down-to=512 512w,https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png?scale-down-to=1024 1024w,https://framerusercontent.com/images/DOPh6i0F3gfgI3TzaQYkACOPw.png 1574w",
        sizes: "165.6842px",
        alt: "",
      }}
    >
      <>
        {step === 1 && (
          <div className={classes.container}>
            <div className={classes.scannerContainer}>
              {cameras.length > 1 && (
                <select
                  value={selectedCamera}
                  onChange={handleCameraChange}
                  className={classes.cameraSelect}
                >
                  {cameras.map((camera) => (
                    <option key={camera.id} value={camera.id}>
                      {camera.label}
                    </option>
                  ))}
                </select>
              )}
              <div id="reader" className={classes.scanner}></div>
              {/* <div className={classes.instructions}>
                Placez le QR Code dans le cadre pour scanner
              </div> */}
              {error && (
                <div className={classes.error}>{error}</div>
              )}
            </div>
          </div>
        )}
        {step === 2 && (
          <div className={classes.container}>
            <div className={classes.scannerContainer}>
              <div className={classes.instructions}>
                Votre présence a été enregistrée avec succès
              </div>

              <Button variant="contained" color="primary" onClick={handleClose}>
                Fermer
              </Button>
            </div>
          </div>
        )}
      </>
    </NewModal>
  );
};

const styles = ({ spacing }) => ({
  container: {
    padding: spacing(2),
  },
  scannerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing(2),
  },
  scanner: {
    width: '100%',
    maxWidth: '400px',
    borderRadius: '8px',
    overflow: 'hidden',
    '& video': {
      borderRadius: '8px',
      width: '100%',
      height: 'auto',
    },
  },
  cameraSelect: {
    width: '100%',
    maxWidth: '400px',
    padding: spacing(1),
    borderRadius: '4px',
    border: '1px solid #ccc',
    marginBottom: spacing(1),
  },
  instructions: {
    textAlign: 'center',
    color: '#5A6DA1',
    fontSize: '14px',
    marginTop: spacing(1),
  },
  error: {
    color: '#f44336',
    textAlign: 'center',
    padding: spacing(2),
  },
});

export default QRScannerModal; 